<ng-container>
  <div mat-dialog-title>
    <span>
      <ng-container *ngIf="!(loading$ | async); else titleSpinner">
        {{ title | translate: {name: customView.name} }}
      </ng-container>
      <ng-template #titleSpinner>
        <app-title-spinner></app-title-spinner>
      </ng-template>
    </span>

    <q9-dialog-close-button></q9-dialog-close-button>
  </div>

  <div class="edit-custom-view-dialog">
    <mat-horizontal-stepper
      class="cv-stepper"
      #stepper
      [linear]="false"
      (selectionChange)="onStepChange($event)">
      <ng-template matStepperIcon="edit">
        <mat-icon svgIcon="edit"></mat-icon>
      </ng-template>

      <mat-step [completed]="true">
        <ng-template matStepLabel>{{ 'RUBIC_CUBE.STEP_SCOPE' | translate }}</ng-template>
      </mat-step>
      <mat-step [completed]="true">
        <ng-template matStepLabel>{{ 'RUBIC_CUBE.STEP_COLUMNS' | translate }}</ng-template>
      </mat-step>
      <mat-step [completed]="true">
        <ng-template matStepLabel>{{ 'RUBIC_CUBE.STEP_FILTERS' | translate }}</ng-template>
      </mat-step>
    </mat-horizontal-stepper>

    <q9-content-loader [isLoading]="loading$ | async"></q9-content-loader>

    <ng-container *ngIf="!(loading$ | async)">
      <ng-container [ngSwitch]="view$ | async">
        <ng-container *ngSwitchCase="viewState.SELECT_METADATA">
          <app-select-metadata-view
            [disableGlobalViewCreation]="customView.private"
            (scopeStateChange)="onScopeStateChange($event)"
            (confirmSelected)="goToColumnsStep()"></app-select-metadata-view>
        </ng-container>

        <ng-container *ngSwitchCase="viewState.SELECT_COLUMNS">
          <app-select-columns-view
            [confirmBtn]="'RUBIC_CUBE.NEXT_BTN'"
            (confirmColumnsSelect)="storeSelectedColumns($event)"
            (cancelColumnsSelect)="switchToMetadataView()"></app-select-columns-view>
        </ng-container>

        <ng-container *ngSwitchCase="viewState.ADD_FILTERS">
          <app-add-filters-view
            (submitForm)="submitFilters($event)"
            (cancelFiltersSelect)="resetFilters()"></app-add-filters-view>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>
</ng-container>
